import { jsx as _jsx } from "preact/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import IconImagesSmall from '@fandom-frontend/react-common/dist/icons/IconImagesSmall';
import useOnScreen from 'pathfinder/modules/shared/useOnScreen';
const StyledIcon = styled.div `
	position: absolute;
	right: 12px;
	bottom: 12px;
	width: 36px;
	height: 36px;
	border-radius: 50%;
	background-color: var(--theme-page-background-color--secondary, #f4f3f4);
	display: flex;
	justify-content: center;
	align-items: center;

	> svg {
		fill: var(--theme-link-color);
	}
`;
const StyledWrapper = styled.div `
	position: absolute;
	width: 100%;
	height: 100%;
`;
const ImageGalleryIconModule = ({ track, config }) => {
    const ref = useRef();
    const onScreen = useOnScreen(ref);
    const [impressionTracked, setImpressionTracked] = useState(false);
    const { placement, imageElement, anchorElement } = config;
    const label = 'image-gallery-icon';
    const onImageClick = () => {
        track.click({
            action: 'click',
            label: `module: ${label}, placement: ${placement}`,
        });
    };
    const onMouseEnter = () => {
        anchorElement.style.verticalAlign = 'bottom';
        anchorElement.style.overflow = 'hidden';
        imageElement.style.cssText = 'transform: scale(1.1); transition: transform 0.3s ease-in-out';
        track({
            action: 'hover',
            label: `module: ${label}, placement: ${placement}`,
        });
    };
    const onMouseLeave = () => {
        imageElement.style.cssText = 'transform: scale(1); transition: transform 0.3s ease-in-out';
    };
    useEffect(() => {
        if (onScreen && !impressionTracked) {
            track.impression({ label });
            setImpressionTracked(true);
        }
    }, [onScreen]);
    return (_jsx(StyledWrapper, Object.assign({ ref: ref, className: "ph-gallery-icon", onClick: onImageClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, { children: _jsx(StyledIcon, { children: _jsx(IconImagesSmall, {}, void 0) }, void 0) }), void 0));
};
export default ImageGalleryIconModule;
